module.exports = __webpack_public_path__ + "img/affiche-afpia.e13d3a3.jpg";